<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            FICHA DE REGISTRO DE FUNCIONÁRIO
          </h4>
          <div class="row">
            <div class="col-6" v-show="tela == 1">
              <BaseFiltroRelatorio tipo="basico" :btDatas="false" @pesquisar="pesquisar" :btEnviarEmail="false" />
            </div>
          </div>
          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button v-show="!printing" type="info" class="animation-on-hover" @click="tela = 1"><i
                    class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button>
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button v-show="!printing" type="info" class="animation-on-hover" @click="imprimirFolha()" simple>
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>
            </div>
            <div v-for="item in dados" :key="`ficha-${item.cpf}`">
              <BaseFichaFuncionario :dados="item" class="break"/>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" loader="spinner" color="#35a887" :is-full-page="true">
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BaseFiltroRelatorio, BaseFichaFuncionario } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import moment from "moment";
import swal from "sweetalert2";
import SocketIO from '../../services/socketIO.js';

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseFichaFuncionario,
    BaseFiltroRelatorio
  },
  data() {
    return {
      isLoading: false,
      dados: [],
      tela: 1,
      printing: false,
      socket: SocketIO,
      payloadPesquisa: Object,
    };
  },
  created() {
    this.conectarSocket();
  },
  beforeUnmount() {
    this.disconectarSocket();
  },
  methods: {

    carregarRelatorioSocket(payload) {
      payload.rota = 'fichaFuncionarios';
      this.emitirEventoSocket('relatorio', payload);
    },
    // SOCKET
    emitirEventoSocket(rota, dados) {
      this.socket.emitir(rota, dados);
    },
    escutarEventosSocket() {
      this.socket.socket.on('relatorio', (data) => {
        if (this.isLoading) {
          this.dados = data.dados;
          this.tela = 2;

          this.isLoading = false;
        }
      })
    },
    conectarSocket() {
      this.socket = new SocketIO(this.$cookies.get("db"));
      this.socket.criarConexao();
      this.escutarEventosSocket();
    },
    disconectarSocket() {
      if (this.socket) {
        this.socket.disconectar();
      }
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false
        });
      }
    },
    moment: function (data) {
      return moment(data);
    },
    pesquisar(event) {
      this.isLoading = true;
      this.payloadPesquisa = event;
      this.carregarRelatorioSocket(event);
    }
  }
};
</script>
<style>
.break {
  page-break-before: always;
}
</style>
